import sessionStrageUtils from '@/lib/sessionStrage/session-strage-utils'
import cookieSessionUtils from '@/lib/cookie/cookie-session-utils'
import { defineObject } from '@/lib/define/use-define'
import { KumasanAuth } from '@/cognito/index'

export const handleOutputJsonFile = (output: string, fileName?: string) => {
  const blob = new Blob([JSON.stringify(JSON.parse(output))], {
    type: 'application/json',
  })

  const url = URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.download = `${fileName ? fileName : 'response'}.json`
  link.click()
  URL.revokeObjectURL(url)
}

export const handleGetOemInfo = () => {
  const oemInfo = sessionStrageUtils.handleGetSessionStorage('oemInfo')

  return oemInfo
}

export const handleGetAppName = () => {
  const oemInfo = sessionStrageUtils.handleGetSessionStorage('oemInfo')

  let appName = defineObject.APP_INFO.appName
  if (oemInfo) {
    appName = oemInfo.oemAppName
  }

  return appName
}

export const handleSetDocumentHtmlTitle = () => {
  const appName = handleGetAppName()

  document.title = appName
}

export const handleIsObject = (value: any) => {
  return value !== null && value !== undefined && typeof value === 'object'
}

export const handleIsObjectInKey = (value: any, key: string) => {
  if (handleIsObject(value) && value[key] !== undefined) {
    return true
  } else {
    return false
  }
}

export const handleAppLogout = () => {
  location.href = '/login'
}

export const handleGoogleLogout = () => {

  const kumasanInstance = new KumasanAuth()

  // 定期的なトークンチェックをクリア
  kumasanInstance.checkTokenClear()

  // cookie削除
  cookieSessionUtils.handleCookieSessionDelete()

  // sessionStorage削除
  sessionStorage.clear()

  location.href =
    process.env.VUE_APP_COGNITO_URL +
    '/logout?client_id=' +
    process.env.VUE_APP_CLIENT_ID +
    '&logout_uri=https://accounts.google.com/Logout'
}

// デバイス判定
export const getDevice = () => {
  let device = ''
  const ua = window.navigator.userAgent.toLowerCase()
  const tablet = ua.indexOf('ipad') > -1 ||
    ua.indexOf('macintosh') > -1 && 'ontouchend' in document ||
    ua.indexOf('Android') > -1
  if(tablet){
    device = 'tablet'
  }else{
    device = 'desktop'
  }
  return device
}